import React, { Component } from 'react';


import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { createEmpty, getWidth, getHeight, extend } from 'ol/extent.js';
import OSM from 'ol/source/OSM.js';

import { defaults as defaultInteractions, Select } from 'ol/interaction.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { Cluster, Stamen, Vector as VectorSource, TileImage } from 'ol/source.js';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text, Icon } from 'ol/style.js';
import { getMainCookie, checkStatus, squareDist, checkText, getFullDate, getSrcLongdo } from '../../../../../util/util';
import { fromLonLat, transform } from 'ol/proj.js';
import Overlay from 'ol/Overlay.js';

import $ from 'jquery'
import { func } from 'prop-types';
import moment from 'moment';
import { defaultColors as m_POIColor, defaultIcons as m_POIIcon, mapColors as m_POIMapColors } from '../../../UserControl/IconColorPicker/POIColorPicker.';
import { defaultColors as m_CarColor, defaultIcons as m_CarIcon, mapColors as m_CarMapColors } from '../../../UserControl/IconColorPicker/IconColorPicker';

// const raster = new TileLayer({
//   source: new OSM()
// });
let raster = new TileLayer({
  //source:  new OSM()
  visible: false,
  source: new TileImage({ url: 'http://mt{0-3}.googleapis.com/vt?lyrs=m@179000000&hl=en&&x={x}&y={y}&z={z}' })
});
let longdo = new TileLayer({
  visible: true,
  // source: new TileImage({ url: 'http://ms.longdo.com/map/msn-server/img.php?c=1&proj=epsg3857&mode=icons&res=4096&zoom={z}&x={x}&y={y}' })
  source: getSrcLongdo()
  
});

let traffic = new TileLayer({
  visible: false,
  source: new TileImage({ url: 'https://mstraffic1.longdo.com/mmmap/img.php?mode=trafficoverlay&HD=1&zoom={z}&x={x}&y={y}' })
});

const sat = new TileLayer(
  {
    visible: false,
    source: new TileImage({ url: 'http://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}' })//'http://khm{0-3}.googleapis.com/kh?v=742&hl=pl&&x={x}&y={y}&z={z}'

  })

const earthquakeFill = new Fill({
  color: 'rgba(255, 153, 0, 0.8)'
});
const earthquakeStroke = new Stroke({
  color: 'rgba(255, 204, 0, 0.2)',
  width: 1
});
const textFill = new Fill({
  color: '#fff'
});
const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3
});
const invisibleFill = new Fill({
  color: 'rgba(255, 255, 255, 0.01)'
});
const iconPinTracker = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car.png',
  scale: 1
}));
const iconPinTracker_select = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car_select.png',
  scale: 1
}));
const iconPinTracker_l = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car_l.png'
}));
const iconPinPOITracker = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_poi.png',
}));
let iconCar = function (icon, color) {
  return new Icon(/** @type {module:ol/style/Icon~Options} */({
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    anchorOrigin: "bottom-left",
    src: isInArray(m_CarIcon, icon) ? 'images/pin/' + icon + '.png' : 'images/pin/car-side.png',
    anchor: [0.48, -30],
    scale: 1,
    // color: isInArray(m_CarColor, color) ? color : "#ff0000"
    color: isInArray(m_CarColor, color) ? m_CarMapColors[color] : color.indexOf("#")>-1?color: "#ff0000"
  }));
}
let iconPOI = function (icon, color) {
  //icon = 'exclamation-triangle';
  return new Icon(/** @type {module:ol/style/Icon~Options} */({
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    anchorOrigin: "bottom-left",
    src: isInArray(m_POIIcon, icon) ? 'images/pin/' + icon + '.png' : 'images/pin/star.png',
    anchor: [0.48, -16],
    color: isInArray(m_POIColor, color) ? m_POIMapColors[color] : color.indexOf("#")>-1?color: "#ff0000"
  }));
}
const iconDirectionN = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionN.png',
  anchor: [0.5, -50],
}));
const iconDirectionNE = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionNE.png',
  anchor: [0.5, -50],
}));
const iconDirectionE = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionE.png',
  anchor: [0.5, -50],
}));
const iconDirectionSE = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionSE.png',
  anchor: [0.5, -50],
}));
const iconDirectionS = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionS.png',
  anchor: [0.5, -50],
}));
const iconDirectionSW = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionSW.png',
  anchor: [0.5, -50],
}));
const iconDirectionW = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionW.png',
  anchor: [0.5, -50],
}));
const iconDirectionNW = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionNW.png',
  anchor: [0.5, -50],
}));

const iconDirectionN_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionN_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionNE_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionNE_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionE_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionE_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionSE_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionSE_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionS_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionS_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionSW_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionSW_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionW_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionW_r.png',
  anchor: [0.5, -50],
}));
const iconDirectionNW_r = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionNW_r.png',
  anchor: [0.5, -50],
}));


const iconDirectionPause = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionPause.png',
  anchor: [0.5, -50],
}));

const iconDirectionStop = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/directionStop.png',
  anchor: [0.5, -50],
}));

const textCarNum = new Text({
  font: '12px sans-serif',
  fill: new Fill({ color: '#C60013' }),
  backgroundFill: new Fill({ color: '#FFC689' }),

  backgroundStroke: new Stroke({
    color: '#C60013',
    width: 1
  }),
  padding: [1, 3, 1, 3],
  offsetY: -20,
});
const textPOIName = new Text({
  fill: textFill,
  stroke: textStroke,
  offsetY: -10,
});

let features = null;
let featuresPOI = null;
let maxFeatureCount;
let currentResolution;
let vector = null;
let map;
let vectorSource = null;

let vectorSourcePOI = null;
let vectorPOI = null;

let container = null;
let content = null;
let closer = null;

let overlay = null;
let marker = null;

function isInArray(arr, txt) {
  let o = arr.filter(a => {
    return a == txt;
  });

  return o.length > 0;
}

function intMap(features) {
  console.log("intMap");
  container = document.getElementById('mapTrackingPopup');
  content = document.getElementById('mapTrackingPopupContent');
  closer = document.getElementById('mapTrackingPopupCloser');

  $("#mapTrackingPopup").show();
  overlay = new Overlay({
    element: container,
    autoPan: true,
    offset: [10, -30],
    autoPanAnimation: {
      duration: 250
    }
  });
  vector = new VectorLayer({
    name: "carVector",
    source: new Cluster({
      distance: 10,
      source: vectorSource
    }),
    style: styleFunction
  });
  map = new Map({
    layers: [raster, longdo, sat, traffic, vector],
    overlays: [overlay],
    interactions: defaultInteractions().extend([new Select({
      condition: function (evt) {
        return evt.type === 'pointermove' ||
          evt.type === 'singleclick';
      },
      style: selectStyleFunction
    })]),
    target: 'mapTracking',
    view: new View({
      center: fromLonLat([100, 13]),
      //projection: 'EPSG:4326',
      minZoom: 5,
      maxZoom: 19,
      zoom: 6
    })
  });

  if (closer != null) {
    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
  }



  let extent = vectorSource.getExtent();
  extent = [extent[0] - 5000, extent[1] - 5000, extent[2] + 5000, extent[3] + 5000];
  //console.log("extent",extent)
  map.getView().fit(extent, map.getSize());

  map.on('singleclick', mapOnClick);
  map.on('pointerdrag', mapOnDrag);
}
function mapOnClick(evt) {

  let lonlat = evt.coordinate;

  let a = [];
  let feature = map.forEachFeatureAtPixel(evt.pixel,
    function (feature) {
      a.push(feature);
    },
    {
      layerFilter: function (layer) {
        return layer.get('name') == 'carVector';
      }
    }
  );

  if (a.length > 0) {
    let minDis = squareDist(lonlat, a[0].get('features')[0].getGeometry().getCoordinates())
    let coordinates = a[0].get('features')[0].getGeometry().getCoordinates();
    let target = a[0];
    for (let i = 0; i < a.length; i++) {
      for (let j = 0; j < a[i].get('features').length; j++) {
        let v = squareDist(lonlat, a[i].get('features')[j].getGeometry().getCoordinates());
        if (minDis > v) {
          minDis = v;
          coordinates = a[i].get('features')[j].getGeometry().getCoordinates();
          target = a[i];
        }
      }
    }
    let imei = target.get('features')[0].get('imei');
    let number = target.get('features')[0].get('number');
    let date = target.get('features')[0].get('date');
    let time = target.get('features')[0].get('time');
    let place = target.get('features')[0].get('place');
    let latitude = target.get('features')[0].get('latitude');
    let longitude = target.get('features')[0].get('longitude');
    let speed = target.get('features')[0].get('speed');
    let driver_name = target.get('features')[0].get('driver_name');
    let driver_contact = target.get('features')[0].get('driver_contact');
    let direction = target.get('features')[0].get('direction');

    vectorSource.refresh();

    $(".balloon-device_no").html(checkText(number, "-", 20));
    $(".balloon-time").html(getFullDate(date) + "," + time);
    $(".balloon-place").html(checkText(place, "-", 100));
    $(".balloon-position").html(latitude + " , " + longitude);
    $(".balloon-speed").html(checkText(speed, "0"));
    $(".balloon-driver_name").html(checkText(driver_name, "-", 15));
    $(".balloon-driver_contact").html(checkText(driver_contact, "-", 15));

    $(".balloon-google_map_position").attr('href', 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude);
    $(".balloon-street_view_position").attr('href', 'https://www.google.com/maps?q&layer=c&cbll=' + latitude + ',' + longitude + '&cbp=11,0,0,0,0')
    //$(".balloon-street_view_position").attr('href', 'https://www.google.com/maps/@'+latitude+','+longitude+',3a,75y,'+direction+'h,91.32t/data=!3m6!1e1!3m4!1s7UKgdaOJgMblR5SnriiWTw!2e0!7i13312!8i6656');
    m_imeiFocus = imei;
    vectorSource.refresh();
    m_props.onSelectCarImei(m_imeiFocus);

    overlay.setPosition(coordinates);
  }
  if (m_props.onPOIMark && m_props.onPOIMark != null && m_isUpdatePOI) {
    m_props.onPOIMark(transform(lonlat, 'EPSG:3857', 'EPSG:4326'));
    $("#marker").show();
    marker = new Overlay({
      //position: lonlat  ,
      //positioning: 'center-center',
      element: document.getElementById('marker'),
      stopEvent: false
    });
    marker.setPosition(lonlat);
    map.addOverlay(marker);
  }
  if (m_props.onSelectPOIMap && m_props.onSelectPOIMap != null && !m_isUpdatePOI) {
    a = [];
    feature = map.forEachFeatureAtPixel(evt.pixel,
      function (feature) {
        a.push(feature);
      },
      {
        layerFilter: function (layer) {
          return layer.get('name') == 'vectorPOI';
        }
      }
    );

    if (a.length > 0) {
      let minDis = squareDist(lonlat, a[0].get('features')[0].getGeometry().getCoordinates())
      let coordinates = a[0].get('features')[0].getGeometry().getCoordinates();
      let target = a[0];
      for (let i = 0; i < a.length; i++) {
        for (let j = 0; j < a[i].get('features').length; j++) {
          let v = squareDist(lonlat, a[i].get('features')[j].getGeometry().getCoordinates());
          if (minDis > v) {
            minDis = v;
            coordinates = a[i].get('features')[j].getGeometry().getCoordinates();
            target = a[i];
          }
        }
      }
      let poi_id = target.get('features')[0].get('poi_id');
      m_props.onSelectPOIMap(poi_id);
    }
  }


}
function mapOnDrag(evt) {
  let lonlat = evt.coordinate;
  //m_imeiFocus = "";
  m_isZoomTo = false;
  //m_props.onSelectCarIndex(-1);

  if (evt.dragging) {
    // overlay.setPosition(undefined);
    // closer.blur();
  }

}
export function clearSelectCar() {
  m_imeiFocus = "";
  m_isZoomTo = false;
  m_props.onSelectCarIndex(-1);
}
function getDirectionStyle(dircetion,isOverSpeed) {
  if (dircetion.toLowerCase() === "n")
    return !isOverSpeed ? iconDirectionN:iconDirectionN_r;
  else if (dircetion.toLowerCase() === "ne")
    return !isOverSpeed ? iconDirectionNE:iconDirectionNE_r;
  else if (dircetion.toLowerCase() === "e")
    return !isOverSpeed ? iconDirectionE:iconDirectionE_r;
  else if (dircetion.toLowerCase() === "se")
    return !isOverSpeed ? iconDirectionSE:iconDirectionSE_r;
  else if (dircetion.toLowerCase() === "s")
    return !isOverSpeed ? iconDirectionS:iconDirectionS_r;
  else if (dircetion.toLowerCase() === "sw")
    return !isOverSpeed ? iconDirectionSW:iconDirectionSW_r;
  else if (dircetion.toLowerCase() === "w")
    return !isOverSpeed ? iconDirectionW:iconDirectionW_r;
  else if (dircetion.toLowerCase() === "nw")
    return !isOverSpeed ? iconDirectionNW:iconDirectionNW_r;
  else if (dircetion.toLowerCase() === "จอด")
    return iconDirectionPause;
  else if (dircetion.toLowerCase() === "ดับ")
    return iconDirectionStop;
  else if (dircetion.toLowerCase() === "เสา")
    return iconDirectionStop;
}

function createEarthquakeStyle(feature, size) {
  let icon = iconPinTracker;
  // if(map.getView().getZoom()>12)
  //   icon = iconPinTracker_l;
  let txtStyle = null;
  textCarNum.setText(feature.get('number').toString());
  let s = feature.get('heading').toString();
  if (feature.get('status').toString() == "จอด" || feature.get('status').toString() == "ดับ" || feature.get('status').toString() == "เสา")
    s = feature.get('status').toString();
  
  let isOverSpeed = false;
  if(feature.get('speed_limit').toString()){
      if(parseInt(feature.get('speed_limit').toString())>0 && parseInt(feature.get('speed_limit').toString()) < parseInt(feature.get('speed').toString()))
        isOverSpeed = true;
  }
  let direction = getDirectionStyle(s,isOverSpeed);
  if (feature.get('status').toString() == "เสา-จอด")
    direction = iconDirectionPause;
  if (feature.get('status').toString() == "เสา-ดับ")
    direction = iconDirectionStop;
  let zIndex = 1;
  // console.log("m_imeiFocus",m_imeiFocus)
  if (feature.get('imei').toString() == m_imeiFocus) {
    console.log("m_imeiFocus xx")
    icon = iconPinTracker_select;
    zIndex = 2;
    txtStyle = new Text({
      font: 'bold 12px sans-serif',
      fill: new Fill({ color: '#000' }),
      backgroundFill: new Fill({ color: '#fff' }),
      backgroundStroke: new Stroke({
        color: '#000',
        width: 1
      }),
      padding: [1, 3, 1, 3],
      offsetY: -20,
      text: feature.get('number').toString()
    }) 
  }


  return [new Style({
    image: icon,
    text: zIndex == 2? txtStyle: textCarNum,
    zIndex: zIndex
  }), new Style({
    image: iconCar(feature.get('symbol_id').toString(), feature.get('symbol_color').toString()),//อาจช้า
    zIndex: zIndex
  }), new Style({
    image: direction,
    zIndex: zIndex
  })]
}

function createEarthquakeStylePOI(feature, size) {
  let icon = iconPinPOITracker;

  if(m_isVisibleName)
    textPOIName.setText(feature.get('number').toString());
  else
    textPOIName.setText("");

  return [new Style({
    image: icon,
    text: textPOIName,
    zIndex: 0
  }), new Style({
    image: iconPOI(feature.get('symbol_id').toString(), feature.get('symbol_color').toString()),//อาจช้า
    zIndex: 0
  })]
}

function createPinGroupOverStyle(feature) {
  return new Style({
    geometry: feature.getGeometry(),
    image: iconPinTracker,
    text: map.getView().getZoom() > 0 ? new Text({
      // fill: textFill,
      // stroke: textStroke,
      font: 'bold 12px sans-serif',
      fill: new Fill({ color: '#000' }),
      backgroundFill: new Fill({ color: '#fff' }),
      backgroundStroke: new Stroke({
        color: '#000',
        width: 1
      }),
      padding: [1, 3, 1, 3],
      offsetY: -20,
      text: feature.get('number').toString()
    }) : null

  })
}
function createPinPOIGroupOverStyle(feature) {
  return new Style({
    geometry: feature.getGeometry(),
    image: iconPinPOITracker,
    text: map.getView().getZoom() > 0 ? new Text({
      fill: textFill,
      stroke: textStroke,
      offsetY: -10,
      text: feature.get('number').toString()
    }) : null

  })
}
function createCarGroupOverStyle(feature) {
  return new Style({
    geometry: feature.getGeometry(),
    image: iconCar(feature.get('symbol_id').toString(), feature.get('symbol_color').toString())//อาจช้า
  })
}
function createPOIGroupOverStyle(feature) {
  return new Style({
    geometry: feature.getGeometry(),
    image: iconPOI(feature.get('symbol_id').toString(), feature.get('symbol_color').toString())//อาจช้า
  })
}
function createDirectionGroupOverStyle(feature) {
  let s = feature.get('heading').toString();
  if (feature.get('status').toString() == "จอด" || feature.get('status').toString() == "ดับ")
    s = feature.get('status').toString();
    
  let isOverSpeed = false;
  if(feature.get('speed_limit').toString()){
      if(parseInt(feature.get('speed_limit').toString()) < parseInt(feature.get('speed').toString()))
        isOverSpeed = true;
  }
  let direction = getDirectionStyle(s,isOverSpeed);
  if (feature.get('status').toString() == "เสา-จอด")
    direction = iconDirectionPause;
  if (feature.get('status').toString() == "เสา-ดับ")
    direction = iconDirectionStop;
  return new Style({
    geometry: feature.getGeometry(),
    image: direction
  })
}


let calculateClusterInfo = function (resolution, isPOI) {
  maxFeatureCount = 0;
  let features;
  if (isPOI)
    features = vectorPOI.getSource().getFeatures();
  else
    features = vector.getSource().getFeatures();
  let feature, radius;
  for (let i = features.length - 1; i >= 0; --i) {
    feature = features[i];
    let originalFeatures = feature.get('features');
    let extent = createEmpty();
    let j = (void 0), jj = (void 0);
    for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
      extend(extent, originalFeatures[j].getGeometry().getExtent());
    }
    maxFeatureCount = Math.max(maxFeatureCount, jj);
    radius = 0.5 * (getWidth(extent) + getHeight(extent)) / resolution;
    feature.set('radius', radius);

  }
};


let styleFunction = function (feature, resolution) {
  if (resolution !== currentResolution) {
    calculateClusterInfo(resolution);
    currentResolution = resolution;
  }
  let style;
  // if(feature.get("number")=="70-1365")
  //   console.log("styleFunction",feature.get("heading"))
  let size = feature.get('features').length;
  // console.log("m_imeiFocus size",size)
  let txt = size.toString();
  if (size > 100)
    txt = (parseInt(size / 100)).toString() + "00+";

  if (map && size > 1 && map.getView() != null && map.getView().getZoom() < 10) {
    let r = 25;
    if (size > 10)
      r = 40;
    else if (size > 30)
      r = 45;
    else if (size > 300)
      r = 50
    else if (size > 1000)
      r = 70
    style = new Style({
      image: new CircleStyle({
        radius: r,//feature.get('radius')
        fill: new Fill({
          color: [255, 153, 0, Math.min(0.8, 0.4 + (size / maxFeatureCount))]
        })
      }),
      text: new Text({
        text: txt,
        fill: textFill,
        stroke: textStroke
      })
    });
  } else {

    let originalFeature = feature.get('features')[0];
    if (m_imeiFocus != "") {
      for (let i = 0; i < feature.get('features').length; i++) {
        if (feature.get('features')[i].get('imei').toString() == m_imeiFocus) {
          originalFeature = feature.get('features')[i];
          break;
        }
      }
    }
    style = createEarthquakeStyle(originalFeature, size);



  }
  return style;
}

let styleFunctionPOI = function (feature, resolution) {
  if (resolution !== currentResolution) {
    calculateClusterInfo(resolution, true);
    currentResolution = resolution;
  }
  let style;
  let size = feature.get('features').length;
  let txt = size.toString();
  if (size > 100)
    txt = (parseInt(size / 100)).toString() + "00+";

  if (map && size > 1 && map.getView().getZoom() < 10) {
    let r = 25;
    if (size > 10)
      r = 40;
    else if (size > 30)
      r = 45;
    else if (size > 300)
      r = 50
    else if (size > 1000)
      r = 70
    style = new Style({
      image: new CircleStyle({
        radius: r,//feature.get('radius')
        fill: new Fill({
          color: [139, 113, 252, Math.min(0.8, 0.4 + (size / maxFeatureCount))]
        })
      }),
      text: new Text({
        text: txt,
        fill: textFill,
        stroke: textStroke
      })
    });
  } else {
    let originalFeature = feature.get('features')[0];
    style = createEarthquakeStylePOI(originalFeature, size);


  }
  return style;
}


function selectStyleFunction(feature) {
  let styles = [new Style({
    image: new CircleStyle({
      radius: feature.get('radius'),
      fill: invisibleFill
    })
  })];
  let originalFeatures = feature.get('features');
  let originalFeature;
  for (let i = originalFeatures.length - 1; i >= 0; --i) {
    originalFeature = originalFeatures[i];
    if ((feature.get('heading') && feature.get('heading') != null)
      || (originalFeatures[i].get('heading') && originalFeatures[i].get('heading') != null)) {
      styles.push(createPinGroupOverStyle(originalFeature));
      styles.push(createCarGroupOverStyle(originalFeature));
      styles.push(createDirectionGroupOverStyle(originalFeature));
    } else {
      styles.push(createPinPOIGroupOverStyle(originalFeature));
      styles.push(createPOIGroupOverStyle(originalFeature));
    }

  }
  return styles;
}

let m_imeiFocus = "";
let m_isZoomTo = true;
let m_trackData = null;
let m_props = null;

export function zoomTo(index, lat, lng) {
  console.log("xxxx",m_trackData)
  if(index != null){
    if(m_trackData.RESULT_DATA[index].device_info.visible == false)
      return;
  }
  
  m_isZoomTo = true;
  let coordinates = fromLonLat([lng, lat]);
  map.getView().setCenter(coordinates);

  if (index != null) {
    if (map.getView().getZoom() < 15)
      map.getView().setZoom(15);
    m_imeiFocus = m_trackData.RESULT_DATA[index].imei;
    if(vectorSource)
      vectorSource.refresh();
    console.log("zoomTo", index, map.getView().getZoom())
  }

}
export function updateMapSize() {
  if (map != null) {
    map.updateSize();
  }
}

export function setCurrentStatus(currentStatus, imei, dtm) {
  let token = getMainCookie().token;
  fetch("http://203.150.199.244/api/report/getPlaybackTrackDuration", {
    method: 'post',
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "token": token
    },
    body: JSON.stringify(
      {
        imei: imei,
        dtm: dtm
      })
  }).then(res => res.json())
    .then(
      (data) => {

        console.log("setSummaryTrack", data.RESULT_DATA)
        $(".balloon-duration").html(data.RESULT_DATA.current_status);
      },
      (error) => {

      }
    );

}

export function setMapToggle(mapTogglePath) {
  if (mapTogglePath.indexOf('type_sat.png') > -1) {
    mapTogglePath = mapTogglePath.replace('type_sat', 'type_map');
    if (m_isGoogleMap)
      raster.setVisible(false);
    else
      longdo.setVisible(false);
    sat.setVisible(true);
  }
  else {
    if (m_isGoogleMap)
      raster.setVisible(true);
    else
      longdo.setVisible(true);
    sat.setVisible(false);
    mapTogglePath = mapTogglePath.replace('type_map', 'type_sat');
  }
  return mapTogglePath;
}
export function setTrafficToggle(trafficTogglePath) {
  if (trafficTogglePath.indexOf('traffic.png') > -1) {
    trafficTogglePath = trafficTogglePath.replace('traffic', 'traffic_a');
    traffic.setVisible(true);
  } else {
    trafficTogglePath = trafficTogglePath.replace('traffic_a', 'traffic');
    traffic.setVisible(false);
  }
  
  return trafficTogglePath;
}


export function switchBaseMap(isGoogle) {
  console.log(isGoogle)
  m_isGoogleMap = isGoogle;
  raster.setVisible(m_isGoogleMap);
  longdo.setVisible(!m_isGoogleMap);
  
}

let m_isGoogleMap = false;
let m_tags = [];
let m_isGroupOrder = false;
function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject("timeout")
    }, ms)
    promise.then(resolve, reject)
  })
}

export function getJSONCar(props, tags, isGroupOrder, isFix) {
  return new Promise((resolve, reject) => {
    if (isFix) {
      m_tags = tags;
      m_imeiFocus = "";
    }
    //if(isGroupOrder)
    m_isGroupOrder = isGroupOrder;

    console.log("m_tags", m_tags, [m_tags].length)
    let token = getMainCookie().token;
    m_props = props;
    fetch("http://203.150.199.244/api/realtime/getTrackingList", {
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "token": token
      },
      body: JSON.stringify({ filter: m_tags, isGroupOrder: m_isGroupOrder })
    }).then((res) => res.json())
      .then(
        (jsonCar) => {
          // this.setState({jsonCar: jsonCar });
          console.log("getJSONCar", jsonCar, props, m_isGroupOrder);
          if (!jsonCar || !jsonCar.RESULT_DATA || jsonCar.RESULT_DATA.length == 0) {
            if (map == null) {
              map = new Map({
                layers: [raster, longdo, sat, traffic],
                // overlays: [overlay],
                interactions: defaultInteractions().extend([new Select({
                  condition: function (evt) {
                    return evt.type === 'pointermove' ||
                      evt.type === 'singleclick';
                  },
                  style: selectStyleFunction
                })]),
                target: 'mapTracking',
                view: new View({
                  center: fromLonLat([100, 13]),
                  //projection: 'EPSG:4326',
                  minZoom: 5,
                  maxZoom: 19,
                  zoom: 6
                })
              })
            }

            return resolve("ok");
          }

          m_trackData = jsonCar;
          props.onGetTrackComplete(jsonCar.RESULT_DATA);
          let count = jsonCar.RESULT_DATA.length;

          features = new Array();
          for (let i = 0; i < count; ++i) {
            let coordinates = fromLonLat([jsonCar.RESULT_DATA[i].longitude, jsonCar.RESULT_DATA[i].latitude]);
            // console.log("coordinates",i)
            // if(i>1)
            // return
            if(jsonCar.RESULT_DATA[i].device_info.visible == false)
              continue;
            features.push( new Feature({
              labelPoint: new Point(coordinates),
              imei: jsonCar.RESULT_DATA[i].imei ? jsonCar.RESULT_DATA[i].imei : "",
              number: jsonCar.RESULT_DATA[i].device_info.icon_label ? jsonCar.RESULT_DATA[i].device_info.icon_label : jsonCar.RESULT_DATA[i].device_info.device_no,
              heading: jsonCar.RESULT_DATA[i].heading ? jsonCar.RESULT_DATA[i].heading : "",
              status: jsonCar.RESULT_DATA[i].status ? jsonCar.RESULT_DATA[i].status : "",
              symbol_id: jsonCar.RESULT_DATA[i].device_info.symbol_id ? jsonCar.RESULT_DATA[i].device_info.symbol_id : "car-side",
              symbol_color: jsonCar.RESULT_DATA[i].device_info.symbol_color ? jsonCar.RESULT_DATA[i].device_info.symbol_color : "#5DADE2",
              latitude: jsonCar.RESULT_DATA[i].latitude ? jsonCar.RESULT_DATA[i].latitude : "",
              longitude: jsonCar.RESULT_DATA[i].longitude ? jsonCar.RESULT_DATA[i].longitude : "",
              speed: jsonCar.RESULT_DATA[i].speed ? jsonCar.RESULT_DATA[i].speed : "0",
              speed_limit: jsonCar.RESULT_DATA[i].device_info.speed_limit ? jsonCar.RESULT_DATA[i].device_info.speed_limit:"9999999",
              place: jsonCar.RESULT_DATA[i].place ? jsonCar.RESULT_DATA[i].place : "",
              date: jsonCar.RESULT_DATA[i].date ? jsonCar.RESULT_DATA[i].date : "",
              time: jsonCar.RESULT_DATA[i].time ? jsonCar.RESULT_DATA[i].time : "",
              driver_name: jsonCar.RESULT_DATA[i].driver_name ? jsonCar.RESULT_DATA[i].driver_name : "",
              driver_contact: jsonCar.RESULT_DATA[i].device_info.driver_contact ? jsonCar.RESULT_DATA[i].device_info.driver_contact : "",
              direction: jsonCar.RESULT_DATA[0].direction ? jsonCar.RESULT_DATA[0].direction : "",
            })
            
            );
            features[features.length-1].setGeometryName('labelPoint');

          }

          if (map == null) {
            vectorSource = new VectorSource({
              features: features
            });
            intMap(features);
          }
          else {
            if(!vectorSource)
              return resolve("ok");
            vectorSource.clear();
            vectorSource.addFeatures(features);
            vectorSource.refresh();
            if (isFix) {
              let extent = vectorSource.getExtent();
              map.getView().fit(extent, map.getSize());
            }
            if (m_imeiFocus != "" && m_isZoomTo) {
              let c = m_trackData.RESULT_DATA.filter(c => {
                if (c.imei == m_imeiFocus)
                  return c;
              })
              if (c.length > 0) {
                m_props.onSelectCarImei(m_imeiFocus);
                zoomTo(null, c[0].latitude, c[0].longitude);
              }

            }
          }
          return resolve("ok");
        },
        (error) => {
          return reject(error);
        }
      )
  });

}
export function getPOI() {
  if (!m_isVisible)
    return;
  let token = getMainCookie().token;
  $("#marker").hide();
  fetch("http://203.150.199.244/api/admin/getPOIList/1/9999999", {
    method: 'post',
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "token": token
    },
    body: JSON.stringify({})
  }).then(res => res.json())
    .then(
      (data) => {

        if (!data || !data.RESULT_DATA)
          return;
        let items = data.RESULT_DATA.filter(t => {
          if (t.is_visible)
            return t;
        });
        let count = items.length;
        console.log("toto", items)
        featuresPOI = new Array(count);
        for (let i = 0; i < count; i++) {
          let coordinates = fromLonLat([Number(items[i].location.longitude), Number(items[i].location.latitude)]);
          featuresPOI[i] = new Feature({
            labelPoint: new Point(coordinates),
            number: items[i].name ? items[i].name : "",
            symbol_id: items[i].icon.name ? items[i].icon.name : "home",
            symbol_color: items[i].icon.color ? items[i].icon.color : "#5DADE2",
            latitude: items[i].location.latitude ? items[i].location.latitude : "",
            longitude: items[i].location.longitude ? items[i].location.longitude : "",
            is_visible: items[i].is_visible ? items[i].is_visible : false,
            poi_id: items[i].poi_id ? items[i].poi_id : "",
          });
          featuresPOI[i].setGeometryName('labelPoint');

        }


        if (vectorPOI == null) {
          console.log(vectorPOI, map, featuresPOI)
          vectorSourcePOI = new VectorSource({
            features: featuresPOI
          });
          vectorPOI = new VectorLayer({
            name: "vectorPOI",
            source: new Cluster({
              distance: 10,
              source: vectorSourcePOI
            }),
            style: styleFunctionPOI
          });
          if (map != null)
            map.getLayers().insertAt(4,vectorPOI);
        }
        else {
          vectorSourcePOI.clear();
          vectorSourcePOI.addFeatures(featuresPOI);
          vectorSourcePOI.refresh();

        }
      },
      (error) => {

      });

}
let timer = null;
let m_isUpdatePOI = false;
let m_isVisible = false;
let m_isVisibleName = true;
export function setUpdatePOI(isUpdatePOI) {
  m_isUpdatePOI = isUpdatePOI;
  if (!m_isUpdatePOI)
    $("#marker").hide();
}
export function setVisiblePOILayer(isVisible) {
  m_isVisible = isVisible;
  if (m_isVisible) {
    if (vectorPOI == null) {
      getPOI();
    } else {
      vectorPOI.setVisible(true);
    }
  } else {
    if (vectorPOI != null) {
      vectorPOI.setVisible(false);
    }
  }

}

export function setVisiblePOIName(isVisible) {
  m_isVisibleName = isVisible;
  if(vectorPOI != null)
    vectorPOI.getSource().refresh();
  // map.getLayers().remove(vectorPOI);
  // vectorPOI = null;
  // getPOI();

}

export function zoomToExtent(lat, long) {
  let coordinates = fromLonLat([Number(long), Number(lat)]);
  map.getView().setCenter(coordinates);
  map.getView().setZoom(15);
}

export function clearMapTracking() {
  console.log("ClearMapTracking");
  // if(map!=null)
  //   map.removeLayer(vector);
  map = null;
  vectorPOI = null;
  m_trackData = null;
  m_imeiFocus = "";
  m_isUpdatePOI = false;
  //m_tags ={};
  clearInterval(timer);
  longdo.setVisible(true);
  sat.setVisible(false);
  traffic.setVisible(false);
  m_isZoomTo = true;
  m_tags = [];
}

export default function mapTracking(props, isGroupOrder) {
  //clearMapTracking();
  map = null;
  if (isGroupOrder != undefined)
    m_isGroupOrder = isGroupOrder;
    getJSONCar(props, m_tags, m_isGroupOrder)
    .then(msg => {
     if (m_isVisible)
        getPOI();
    }
    );
  timer = setInterval(() => getJSONCar(props, m_tags, m_isGroupOrder), 30000);


}







// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MapTracking/js/MapTracking.js